// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__DlGVy","border":"Tab_border__Wtzlz","borderPrimary":"Tab_borderPrimary__IPuuS","button":"Tab_button__M3jGk"};